import React, { useEffect, useRef, useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { getValue, setValue } from "@utils/lodash";
import { useNavigate } from "react-router-dom";
import NoAccessPage from "@components/common/NoAccess";
import MoreReportSvgComponent from "../../../assets/svg-components/left-menu/more-report";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
import { QueryRequestHelper } from "@_common/query-request-helper";
import { clientGetLocation } from "@services/location.service";
import "./index.scss";
import { legalUpdate } from "@services/reports.service";
import ReportsNotfoundNoLink from "@components/Page-Not-Found/reports-not-found-nolink";
import Loader from "@components/common/Loader";
import { concatString, decodeBase64 } from "@_common/text-helpers";
import {
  convertCurrentDateWithTime,
  convertDate,
  convertDateAsString,
} from "@_common/date-helpers";
import LegalUpdateFilterForm from "./filter";
import {
  adminGetSCCountriesListManagement,
  adminGetSCStatesListManagement,
  getSmartFilterListManagementList,
} from "@services/list-management.service";
import { toast } from "react-toastify";
import BlogsViewPopup from "./view-blogs";
import FooterWrapper from "@components/common/FooterWrapper";

const ReportsLegalUpdate = (props: any) => {
  let navigate = useNavigate();
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = useState(true);
  const [legalList, setLegalList] = useState([]);
  const [filterIsOpen, setFilterIsOpen] = useState(false);
  const handleFilter = () => {
    setFilterIsOpen(!filterIsOpen);
  };

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getTagsList("", "");
      getStateList("", "");
      getIndustryList("", "");
      getRegulationList("", "");
      getministryList("", "");
      getDepartmentList("", "");
      getNotificationTypeList("", "");
      getCountriesList();
      getData();
      let dates = params.date ? new Date(params.date) : new Date();
      var from_date = new Date(dates.getFullYear(), dates.getMonth(), 1);
      var to_date = new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
      setFirstDay(from_date);
      setLastDay(to_date);
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      let selectedIDs: any = urlSearchParams.getAll("industries[]");
      getTagsList("", "");
      getStateList("", "");
      getIndustryList("", "");
      getRegulationList("", "");
      getministryList("", "");
      getDepartmentList("", "");
      getNotificationTypeList("", "");
      getCountriesList();
      getData();

      setRequest({
        ...request,
        country_id: getValue(params, `country_id`, ""),
        state_id: getValue(params, `state_id`, ""),
        industry_id: getValue(params, `industry_id`, ""),
        regulation_id: getValue(params, `regulation_id`, ""),
        ministry_id: getValue(params, `ministry_id`, ""),
        department_id: getValue(params, `department_id`, ""),
        notification_type_id: getValue(params, `notification_type`, ""),
      });

      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }

      if (params.from_date && params.to_date) {
        // setDate(new Date(params.date));
        var from_date = new Date(params.from_date);
        var to_date = new Date(params.to_date);
        setFirstDay(from_date);
        setLastDay(to_date);
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */
  const getPayload = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let industrySelectedIDs: any = urlSearchParams.getAll("industries[]");
    let regulationSelectedIDs: any = urlSearchParams.getAll("regulations[]");
    let ministrySelectedIDs: any = urlSearchParams.getAll("ministries[]");
    let departmentSelectedIDs: any = urlSearchParams.getAll("departments[]");
    let statesSelectedIDs: any = urlSearchParams.getAll("states[]");
    let tagsSelectedIDs: any = urlSearchParams.getAll("tags[]");
    let notificationTypeSelectedIDs: any = urlSearchParams.getAll(
      "notification_type[]"
    );

    // let notificationTypeSelectedIDs: any = urlSearchParams.getAll("notification_type");

    // let compliance_task_ids: any = urlSearchParams.getAll(
    //   "compliance_task_ids[]"
    // );

    let dates = params.date ? new Date(params.date) : new Date();
    var from_date = params.from_date
      ? params.from_date
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var to_date = params.to_date
      ? params.to_date
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
    let payload: any = {
      from_date: getValue(params, `is_all_time`, "")
        ? ""
        : getValue(params, `from_date`, "")
        ? getValue(params, `from_date`, "")
        : convertDate(from_date),
      to_date: getValue(params, `is_all_time`, "")
        ? ""
        : getValue(params, `to_date`, "")
        ? getValue(params, `to_date`, "")
        : convertDate(to_date),
      // compliance_status: getValue(params, `compliance_status`, ""),
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      sort_by: params.sort_by,
      search_text: params.search_text,
      country_id: parseInt(getValue(params, `country_id`, "")),
      // state_id: parseInt(getValue(params, `state_id`, "")),
      // compliance_type_id: getValue(params, `compliance_type_id`, ""),
      // self_compliance_task_ids: compliance_task_ids,
      industries:
        industrySelectedIDs.length > 0
          ? industrySelectedIDs.map((item: string) => ({ id: item }))
          : [],
      regulations:
        regulationSelectedIDs.length > 0
          ? regulationSelectedIDs.map((item: string) => ({ id: item }))
          : [],
      ministries:
        ministrySelectedIDs.length > 0
          ? ministrySelectedIDs.map((item: string) => ({ id: item }))
          : [],
      departments:
        departmentSelectedIDs.length > 0
          ? departmentSelectedIDs.map((item: string) => ({ id: item }))
          : [],
      states:
        statesSelectedIDs.length > 0
          ? statesSelectedIDs.map((item: string) => ({ id: item }))
          : [],
      tags:
        tagsSelectedIDs.length > 0
          ? tagsSelectedIDs.map((item: string) => ({ id: item }))
          : [],
      notification_type:
        notificationTypeSelectedIDs.length > 0
          ? notificationTypeSelectedIDs.map((item: string) => ({ id: item }))
          : [],
      // notification_type : notificationTypeSelectedIDs[0]

      // status: getValue(params, `status`, "")
      //   ? getValue(params, `status`, "")
      //   : "active",
      // request_from:
      //   getValue(compliance_task_ids, `length`, 0) > 0
      //     ? ""
      //     : getValue(params, `request_from`, "")
      //     ? getValue(params, `request_from`, "")
      //     : "MASTER",
    };
    return { ...payload };
  };

  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
      // is_active: true,
    };
    // let queryRequest = QueryRequestHelper(payload);
    let payloadObj = await getPayload();
    let queryRequest = QueryRequestHelper({
      ...payload,
      ...payloadObj,
    });

    try {
      setIsLoading(true);
      let resp = await legalUpdate({ ...payload, ...payloadObj });
      if (resp) {
        setLegalList(getValue(resp, `data.blogData`, []));
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(100);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    setSearchInput(e.target.value);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: 1,
      search_text: e.target.value,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  let payload = {
    loc_page_no: getValue(params, `page_no`, "1"),
    loc_search_text: getValue(params, `search_text`, ""),
  };
  let queryRequest = QueryRequestHelper(payload);

  /* -------------------------------------------------------------------------- */
  /*                              Date Routes                                   */
  /* -------------------------------------------------------------------------- */
  const [from_date, setFirstDay] = React.useState(new Date());
  const [to_date, setLastDay] = React.useState(new Date());
  const handleDate = (date: any) => {
    setFirstDay(date[0]);
    setLastDay(date[1]);
  };

  const datePickerRef = useRef<any>(null); // Specify the type explicitly

  const handleSubmitDate = () => {
    let first = convertDate(from_date);
    let last = convertDate(to_date);
    if (first && last && first !== "Invalid date" && last !== "Invalid date") {
      let payload: any = {
        ...params,
        from_date: first,
        to_date: last,
      };
      if (payload.from_date && payload.to_date) {
        let queryRequest = QueryRequestHelper(payload);
        navigate(`${window.location.pathname}?${queryRequest}`);
        if (datePickerRef.current) {
          datePickerRef.current.setOpen(false);
        }
      } else {
        toast.error("Start Date and End Date Required");
      }
    } else {
      toast.error("Please select date");
    }
  };

  const resetDate = () => {
    delete params.from_date;
    delete params.to_date;
    let payload: any = {
      ...params,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    let dates = new Date();
    var from_date = new Date(dates.getFullYear(), dates.getMonth(), 1);
    var to_date = new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
    setFirstDay(from_date);
    setLastDay(to_date);
  };

  const handleCancelDate = () => {
    datePickerRef.current.setOpen(false);
    resetDate();
    getData();
  };
  /* -------------------------------------------------------------------------- */
  /*                               Filter Section                               */
  /* -------------------------------------------------------------------------- */
  const [countryList, setCountryList] = useState([]);
  const [states, setStates] = useState([]);

  /* ---------------------------  Country List  ----------------------------- */
  const getCountriesList = async () => {
    try {
      // let resp = await adminGetCountriesListManagement();
      let payload = await getPayload();
      let queryRequest = QueryRequestHelper(payload);
      let resp = await adminGetSCCountriesListManagement(queryRequest);
      if (resp) {
        setCountryList(
          getValue(resp, `data`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `country_id`, ""),
            value: getValue(item, `country_name`, ""),
            label: getValue(item, `country_name`, ""),
          }))
        );
      } else {
      }
    } catch (error) {}
  };

  /* ---------------------------  State List  ----------------------------- */
  const getStatesList = async (countryId: number) => {
    if (countryId) {
      let payload = await getPayload();
      let queryRequest = QueryRequestHelper({ ...payload, country: countryId });
      try {
        // let resp = await adminGetStatesListManagement(countryId);
        let resp = await adminGetSCStatesListManagement(queryRequest);
        if (resp) {
          setStates(
            getValue(resp, `data`, []).map((item: object) => ({
              ...item,
              id: getValue(item, `state_id`, ""),
              value: getValue(item, `state_name`, ""),
              label: getValue(item, `state_name`, ""),
            }))
          );
        } else {
        }
      } catch (error) {}
    } else {
      setValue(request, `state_id`, "");
      setRequest({ ...request });
    }
  };

  const [request, setRequest] = useState<any>({
    country_id: "101",
    state_id: "",
    industry_id: "",
    regulation_id: "",
    ministry_id: "",
    department_id: "",
    notification_type_id: "",
  });

  const reset = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      page_no: params.page_no,
      search_text: getValue(params, `search_text`, ""),
      limit: getValue(params, `limit`, ""),
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    getData();
    reset1();
  };
  const [resetInput, setResetInput] = useState(false);
  const reset1 = () => {
    setRequest({
      ...request,
      state_id: "",
      industry_id: "",
      regulation_id: "",
      ministry_id: "",
      department_id: "",
      notification_type_id: "",
    });
    setSelectedStatesListIds([]);
    setSelectedTagsListIds([]);
    setSelectedIndustryListIds([]);
    setSelectedRegulationListIds([]);
    setSelectedMinistryListIds([]);
    setSelectedDepartmentListIds([]);
    setSelectedNotificationTypeListIds([]);
    setResetInput(true);
    // setFilterVisibility(false);
  };

  useEffect(() => {
    getStatesList(request.country_id);
  }, [request.country_id]);

  // Multi States
  const [statesList, setStatesList] = useState([]);
  const [selectedStatesListIds, setSelectedStatesListIds] = useState<any>([]);
  const handleChangeStateMulti = (e: any) => {
    setSelectedStatesListIds(e);
  };

  const getStateList = async (value: string, id: string) => {
    try {
      let payload = await getPayload();
      let queryRequest = QueryRequestHelper({ ...payload, country: "101" });
      let resp = await adminGetSCStatesListManagement(queryRequest);
      if (resp) {
        let list: any = getValue(resp, `data`, []).map((item: object) => ({
          ...item,
          id: getValue(item, `state_id`, ""),
          value: getValue(item, `state_name`, ""),
          label: getValue(item, `state_name`, ""),
        }));

        let selectedIDs: any = urlSearchParams.getAll("states[]");
        setStatesList(list);

        let selectedList =
          getValue(list, `length`, 0) > 0
            ? list.filter((item: object) =>
                selectedIDs.includes(getValue(item, `id`, []).toString())
              )
            : [];
        setSelectedStatesListIds(selectedList);
      } else {
        // setEventLoading(false);
      }
    } catch (error) {
      // setEventLoading(false);
    }
    if (!value) {
      setValue(request, `industry_id`, "");
    }
  };

  // Tags List
  const [tagsList, setTagsList] = useState([]);
  const [selectedTagsListIds, setSelectedTagsListIds] = useState<any>([]);
  const handleChangeTagsMulti = (e: any) => {
    setSelectedTagsListIds(e);
  };

  const getTagsList = async (value: string, id: string) => {
    try {
      let payload = {
        page_no: 1,
        page_size: 10,
        search_text: value,
        id: id,
        // group_id: "36", //
        group_code: "tags",
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getSmartFilterListManagementList(queryRequest);
      if (resp) {
        let list: any = getValue(resp, `data.listItems`, []).map(
          (item: object) => ({
            ...item,
            value: getValue(item, `text`, ""),
            label: getValue(item, `text`, ""),
          })
        );
        let selectedIDs: any = urlSearchParams.getAll("tags[]");
        setTagsList(list);

        let selectedList =
          getValue(list, `length`, 0) > 0
            ? list.filter((item: object) =>
                selectedIDs.includes(getValue(item, `id`, []).toString())
              )
            : [];
        setSelectedTagsListIds(selectedList);
      } else {
        // setEventLoading(false);
      }
    } catch (error) {
      // setEventLoading(false);
    }
    if (!value) {
      setValue(request, `industry_id`, "");
    }
  };

  //Industry List
  const [industryList, setIndustryList] = useState([]);
  const [selectedIndustryListIds, setSelectedIndustryListIds] = useState<any>(
    []
  );
  const handleChangeSelectMulti = (e: any) => {
    setSelectedIndustryListIds(e);
  };

  const getIndustryList = async (value: string, id: string) => {
    try {
      let payload = {
        page_no: 1,
        page_size: 10,
        search_text: value,
        id: id,
        // group_id: "36", //
        group_code: "industry",
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getSmartFilterListManagementList(queryRequest);
      if (resp) {
        let list: any = getValue(resp, `data.listItems`, []).map(
          (item: object) => ({
            ...item,
            value: getValue(item, `text`, ""),
            label: getValue(item, `text`, ""),
          })
        );
        let selectedIDs: any = urlSearchParams.getAll("industries[]");
        setIndustryList(list);

        let selectedList =
          getValue(list, `length`, 0) > 0
            ? list.filter((item: object) =>
                selectedIDs.includes(getValue(item, `id`, []).toString())
              )
            : [];
        setSelectedIndustryListIds(selectedList);
      } else {
        // setEventLoading(false);
      }
    } catch (error) {
      // setEventLoading(false);
    }
    if (!value) {
      setValue(request, `industry_id`, "");
    }
  };

  const [regulationList, setRegulationList] = useState([]);
  const [selectedRegulationListIds, setSelectedRegulationListIds] =
    useState<any>([]);

  const handleChangeRegulationMulti = (e: any) => {
    setSelectedRegulationListIds(e);
  };

  const getRegulationList = async (value: string, id: string) => {
    try {
      let payload = {
        page_no: 1,
        page_size: 10,
        search_text: value,
        id: id,
        // group_id: "36", //
        group_code: "regulations",
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getSmartFilterListManagementList(queryRequest);
      if (resp) {
        let list: any = getValue(resp, `data.listItems`, []).map(
          (item: object) => ({
            ...item,
            value: getValue(item, `text`, ""),
            label: getValue(item, `text`, ""),
          })
        );
        let selectedIDs: any = urlSearchParams.getAll("regulations[]");
        setRegulationList(list);

        let selectedList =
          getValue(list, `length`, 0) > 0
            ? list.filter((item: object) =>
                selectedIDs.includes(getValue(item, `id`, []).toString())
              )
            : [];
        setSelectedRegulationListIds(selectedList);
      } else {
        // setEventLoading(false);
      }
    } catch (error) {
      // setEventLoading(false);
    }
    if (!value) {
      setValue(request, `regulation_id`, "");
    }
  };

  const [ministryList, setMinistryList] = useState([]);
  const [selectedMinistryListIds, setSelectedMinistryListIds] = useState<any>(
    []
  );

  const handleChangeMinistryMulti = (e: any) => {
    setSelectedMinistryListIds(e);
  };

  const getministryList = async (value: string, id: string) => {
    try {
      let payload = {
        page_no: 1,
        page_size: 10,
        search_text: value,
        id: id,
        // group_id: "36", //
        group_code: "ministries",
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getSmartFilterListManagementList(queryRequest);
      if (resp) {
        // setMinistryList(
        //   getValue(resp, `data.listItems`, []).map((item: object) => ({
        //     ...item,
        //     value: getValue(item, `text`, ""),
        //     label: getValue(item, `text`, ""),
        //   }))
        // );
        // setValue(request, `ministry_id`, "");
        let list: any = getValue(resp, `data.listItems`, []).map(
          (item: object) => ({
            ...item,
            value: getValue(item, `text`, ""),
            label: getValue(item, `text`, ""),
          })
        );
        let selectedIDs: any = urlSearchParams.getAll("ministries[]");
        setMinistryList(list);

        let selectedList =
          getValue(list, `length`, 0) > 0
            ? list.filter((item: object) =>
                selectedIDs.includes(getValue(item, `id`, []).toString())
              )
            : [];
        setSelectedMinistryListIds(selectedList);
      } else {
        // setEventLoading(false);
      }
    } catch (error) {
      // setEventLoading(false);
    }
    if (!value) {
      setValue(request, `ministry_id`, "");
    }
  };

  const [departmentList, setDepartmentlist] = useState([]);
  const [selectedDepartmentListIds, setSelectedDepartmentListIds] =
    useState<any>([]);

  const handleChangeDepartmentMulti = (e: any) => {
    setSelectedDepartmentListIds(e);
  };

  const getDepartmentList = async (value: string, id: string) => {
    try {
      let payload = {
        page_no: 1,
        page_size: 10,
        search_text: value,
        id: id,
        // group_id: "36", //
        group_code: "departments",
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getSmartFilterListManagementList(queryRequest);
      if (resp) {
        // setDepartmentlist(
        //   getValue(resp, `data.listItems`, []).map((item: object) => ({
        //     ...item,
        //     value: getValue(item, `text`, ""),
        //     label: getValue(item, `text`, ""),
        //   }))
        // );
        // setValue(request, `department_id`, "");
        let list: any = getValue(resp, `data.listItems`, []).map(
          (item: object) => ({
            ...item,
            value: getValue(item, `text`, ""),
            label: getValue(item, `text`, ""),
          })
        );
        let selectedIDs: any = urlSearchParams.getAll("departments[]");
        setDepartmentlist(list);

        let selectedList =
          getValue(list, `length`, 0) > 0
            ? list.filter((item: object) =>
                selectedIDs.includes(getValue(item, `id`, []).toString())
              )
            : [];
        setSelectedDepartmentListIds(selectedList);
      } else {
        // setEventLoading(false);
      }
    } catch (error) {
      // setEventLoading(false);
    }
    if (!value) {
      setValue(request, `department_id`, "");
    }
  };

  const [notificationTypeList, setNotificationTypeList] = useState([]);
  const [selectedNotificationTypeListIds, setSelectedNotificationTypeListIds] =
    useState<any>([]);

  const handleChangeNotificationTypeMulti = (e: any) => {
    setSelectedNotificationTypeListIds(e);
  };

  const getNotificationTypeList = async (value: string, id: string) => {
    try {
      let payload = {
        page_no: 1,
        page_size: 10,
        search_text: value,
        id: id,
        // group_id: "36", //
        group_code: "notification-type",
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getSmartFilterListManagementList(queryRequest);
      if (resp) {
        let list: any = getValue(resp, `data.listItems`, []).map(
          (item: object) => ({
            ...item,
            value: getValue(item, `text`, ""),
            label: getValue(item, `text`, ""),
          })
        );
        let selectedIDs: any = urlSearchParams.getAll("notification_type[]");
        setNotificationTypeList(list);

        let selectedList =
          getValue(list, `length`, 0) > 0
            ? list.filter((item: object) =>
                selectedIDs.includes(getValue(item, `id`, []).toString())
              )
            : [];
        setSelectedNotificationTypeListIds(selectedList);
      } else {
        // setEventLoading(false);
      }
    } catch (error) {
      // setEventLoading(false);
    }
    if (!value) {
      setValue(request, `notification_type_id`, "");
    }
  };

  /* -------------Onchange Smart Filter--------------- */
  const handleChangeSelect = (e: any, type: string) => {
    if (type === "country_id") {
      getStatesList(e.id);
      setStates([]);
      setRequest({
        ...request,
        country_id: e.id,
        state_id: "",
        industry_id: "",
        regulation_id: "",
        ministry_id: "",
        department_id: "",
        notification_type_id: "",
      });
    }
    if (type === "state_id") {
      if (!getValue(e, `id`, "")) {
        setValue(request, `id`, "");
        setRequest({
          ...request,
          state_id: "",
          industry_id: "",
          regulation_id: "",
          ministry_id: "",
          department_id: "",
          notification_type_id: "",
        });
      } else {
        setRequest({
          ...request,
          state_id: getValue(e, `id`, "") ? e.id : "",
          industry_id: "",
          regulation_id: "",
          ministry_id: "",
          department_id: "",
          notification_type_id: "",
        });
      }
    }
  };

  const handleSubmitSmartFilter = () => {
    let selectedIndustryListIdsPayload = JSON.parse(
      JSON.stringify(selectedIndustryListIds)
    );
    let selectedRegulationListIdsPayload = JSON.parse(
      JSON.stringify(selectedRegulationListIds)
    );
    let selectedMinistryListIdsPayload = JSON.parse(
      JSON.stringify(selectedMinistryListIds)
    );
    let selectedDepartmentListIdsPayload = JSON.parse(
      JSON.stringify(selectedDepartmentListIds)
    );
    let selectedStatesListIdsPayload = JSON.parse(
      JSON.stringify(selectedStatesListIds)
    );
    let selectedTagsListIdsPayload = JSON.parse(
      JSON.stringify(selectedTagsListIds)
    );
    let selectedNotificationTypeListIdsPayload = JSON.parse(
      JSON.stringify(selectedNotificationTypeListIds)
    );

    // let levelObj: any = {};
    // //finding only levels params if it presented in URL
    // for (let i = 1; i < 11; i++) {
    //   if (getValue(paramsObj, `level${i}`, "")) {
    //     levelObj[`level${i}`] = getValue(paramsObj, `level${i}`, "");
    //   }
    // }
    // if (
    // 	getValue(request, `country_id`, "")
    // 	// getValue(request, `state_id`, "")
    // 	// && getValue(request, `category_of_law_id`, "") &&
    // 	// getValue(request, `legislation_id`, "") &&
    // 	// getValue(request, `legislation_rule_id`, "")
    // ) {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: params.page_no,
      country_id: getValue(request, `country_id`, ""),
      state_id: getValue(request, `state_id`, ""),
      search_text: getValue(params, `search_text`, ""),
      limit: getValue(params, `limit`, ""),
      industries:
        selectedIndustryListIdsPayload.length > 0
          ? selectedIndustryListIdsPayload.map((item: object) =>
              getValue(item, `id`, "")
            )
          : [],
      regulations:
        selectedRegulationListIdsPayload.length > 0
          ? selectedRegulationListIdsPayload.map((item: object) =>
              getValue(item, `id`, "")
            )
          : [],
      ministries:
        selectedMinistryListIdsPayload.length > 0
          ? selectedMinistryListIdsPayload.map((item: object) =>
              getValue(item, `id`, "")
            )
          : [],
      departments:
        selectedDepartmentListIdsPayload.length > 0
          ? selectedDepartmentListIdsPayload.map((item: object) =>
              getValue(item, `id`, "")
            )
          : [],
      states:
        selectedStatesListIdsPayload.length > 0
          ? selectedStatesListIdsPayload.map((item: object) =>
              getValue(item, `id`, "")
            )
          : [],
      tags:
        selectedTagsListIdsPayload.length > 0
          ? selectedTagsListIdsPayload.map((item: object) =>
              getValue(item, `id`, "")
            )
          : [],
      notification_type:
        selectedNotificationTypeListIdsPayload.length > 0
          ? selectedNotificationTypeListIdsPayload.map((item: object) =>
              getValue(item, `id`, "")
            )
          : [],
    };
    let queryRequest = QueryRequestHelper({ ...payload });
    navigate(`${window.location.pathname}?${queryRequest}`);
    handleFilter();
    // } else {
    // 	toast.error("All fields are mandatory");
    // }
  };

  //blogs Popup
  const [showBlogsPopup, setShowBlogsPopup] = useState(false);
  const [blogInfo, setBlogInfo] = useState({});
  const handleViewBlogs = async (data: object) => {
    setShowBlogsPopup(true);
    setBlogInfo(data);
  };

  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "repository_legal_update"
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="header-parent-icon-holder">
                <MoreReportSvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Reports
                </h6>
                <h4 className="dashbaord-wrapper__header-title">
                  Legal Update
                </h4>
              </div>
            </div>

            <div className="d-flex align-items-center">
              <RightMenuHeaders
                licenseStyleCalendar={true}
                // date range
                dateRange={true}
                from_date={from_date}
                to_date={to_date}
                handleDate={handleDate}
                handleCancelDate={handleCancelDate}
                handleSubmitDate={handleSubmitDate}
                datePickerRef={datePickerRef}
                //search
                isSearch={true}
                searchInput={search_text}
                showSearchTextbox={showSearchTextbox}
                toggleSearch={toggleSearch}
                toggleSearchClose={toggleSearchClose}
                handleChangeSearch={handleChangeSearch}
                //smartFilter
                smartFilter={true}
                handleFilter={handleFilter}
                //Line Seperator of button
                lineSeperator={true}

                //Add
                // isAdd={
                //     getValue(props, `permissions`, []).includes("create")
                //       ? "true"
                //       : "false"
                // }
                // isAdd={"true"}
                add={"false"}
                route={"/repository/legal-update/create"}
              />
            </div>
          </div>

          <div className={`main-page-layout-wrapper`}>
            <div className="admin-wrapper position-relative">
              <LegalUpdateFilterForm
                filterIsOpen={filterIsOpen}
                handleFilter={handleFilter}
                handleSubmitSmartFilter={handleSubmitSmartFilter}
                //States and Country
                countryList={countryList}
                states={states}
                handleChangeSelect={handleChangeSelect}
                //States Multi
                statesList={statesList}
                handleChangeStateMulti={handleChangeStateMulti}
                selectedStatesListIds={selectedStatesListIds}
                //Tags
                tagsList={tagsList}
                handleChangeTagsMulti={handleChangeTagsMulti}
                selectedTagsListIds={selectedTagsListIds}
                //Industry
                industryList={industryList}
                handleChangeSelectMulti={handleChangeSelectMulti}
                selectedIndustryListIds={selectedIndustryListIds}
                //Regulations
                regulationList={regulationList}
                selectedRegulationListIds={selectedRegulationListIds}
                handleChangeRegulationMulti={handleChangeRegulationMulti}
                //Ministry
                ministryList={ministryList}
                selectedMinistryListIds={selectedMinistryListIds}
                handleChangeMinistryMulti={handleChangeMinistryMulti}
                //Department
                departmentList={departmentList}
                selectedDepartmentListIds={selectedDepartmentListIds}
                handleChangeDepartmentMulti={handleChangeDepartmentMulti}
                //notificationType
                notificationTypeList={notificationTypeList}
                selectedNotificationTypeListIds={
                  selectedNotificationTypeListIds
                }
                handleChangeNotificationTypeMulti={
                  handleChangeNotificationTypeMulti
                }
                //Title Section
                moduleName={"Reports"}
                subModuleName={"Legal Update"}
                //CTA
                reset={reset}
              />
              {isLoading || !props.permissionAPITriggered ? (
                <Loader />
              ) : // getValue(legalList, `length`, 0)
              legalList.length > 0 ? (
                <>
                  <div className="legal-update-main-wrap">
                    <div className="legal-update-card-holder">
                      {legalList.map((legalObj: any, index: any) => {
                        let html: any = concatString(
                          decodeBase64(getValue(legalObj, "content", "")),
                          250
                        );
                        return (
                          <div
                            className="legal-update-card cursor-pointer"
                            onClick={() => {
                              handleViewBlogs(legalObj);
                            }}
                          >
                            <div className="legal-tags-wrap d-flex">
                              {getValue(legalObj, `tags`, []).map(
                                (tagObj: any, index: any) => {
                                  return (
                                    <>
                                      <div className="legal-tags" title={getValue(tagObj, `text`, "")}>
                                        {getValue(tagObj, `text`, "")}
                                      </div>
                                    </>
                                  );
                                }
                              )}

                              <div
                                className="legal-tags states-name-tags"
                                title={getValue(legalObj, `states.name`, "")}
                              >
                                {getValue(legalObj, `states.name`, "")}
                              </div>
                            </div>

                            <div className="legal-title">
                              {concatString(
                                getValue(legalObj, `title`, ""),
                                80
                              )}
                            </div>
                            <div className="legal-timestamp">
                              {convertCurrentDateWithTime(
                                getValue(legalObj, `updated_at`, "")
                              )}
                            </div>
                            <div
                              className="legal-desc"
                              dangerouslySetInnerHTML={{ __html: html }}
                            ></div>

                            <div className="text-right read-more-link">
                              <a
                                onClick={() => {
                                  handleViewBlogs(legalObj);
                                }}
                              >
                                Read More
                              </a>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <FooterWrapper
                    list={legalList}
                    totalCount={totalCount}
                    limit={limit}
                    page_no={page_no}
                    handleChangePagination={handleChangePagination}
                    handleChangeLimit={handleChangeLimit}
                  />
                </>
              ) : (
                <>
                  {Object.keys(params).length !== 0 ? (
                    <>
                      <ReportsNotfoundNoLink />
                    </>
                  ) : (
                    <ReportsNotfoundNoLink />
                  )}
                </>
              )}

              <BlogsViewPopup
                showBlogsPopup={showBlogsPopup}
                setShowBlogsPopup={setShowBlogsPopup}
                // editorState={editorState}
                // onEditorStateChange={onEditorStateChange}
                blogInfo={blogInfo}
              />
            </div>
          </div>
        </>
      )}
    </DashboardLayout>
  );
};

export default ReportsLegalUpdate;
